module.exports = __webpack_public_path__ + "static/media/dlp_mobile.9b60c6c2.png";